/** The hour an invitation downloaded for a meeting without a date starts at, in the manager's time. */
export const DEFAULT_INVITATION_HOUR = 9;

const DAYS_IN_A_WEEK = 7;

/**
 * When the invitation of a meeting without a date starts: the same weekday next week, at 9:00 in the
 * manager's own time zone. Built from the local calendar parts rather than by adding milliseconds, so
 * a daylight-saving change in between still lands on 9:00. The manager moves it in their calendar.
 */
export const getDefaultInvitationStart = (now: Date = new Date()): Date =>
    new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + DAYS_IN_A_WEEK,
        DEFAULT_INVITATION_HOUR,
    );
